// src/pages/ProductoAdmin.js

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../../Config'; // ajustá la ruta si es distinta


const ProductoAdmin = () => {
  const [productos, setProductos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProductos = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/productos`);
        setProductos(response.data);
        setCargando(false);
      } catch (err) {
        console.error(err);
        setError('Error al cargar productos');
        setCargando(false);
      }
    };

    fetchProductos();
  }, []);

  const manejarAgregar = () => {
    navigate('/registro-producto');
  };

  const manejarEditar = (id) => {
    navigate(`/editar-producto/${id}`);
  };

  const manejarCategorias = () => {
    navigate('/admin-categorias');
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4 flex flex-col items-center">
      <div className="bg-white shadow-lg rounded-lg w-full max-w-4xl p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold">Listado de Productos</h2>
          <div className="flex space-x-2">
            <button
              onClick={manejarCategorias}
              className="bg-purple-600 text-white px-4 py-2 rounded hover:bg-purple-700"
            >
              Categorías
            </button>
            <button
              onClick={manejarAgregar}
              className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
            >
              + Agregar Producto
            </button>
          </div>
        </div>

        {cargando ? (
          <p className="text-gray-600">Cargando productos...</p>
        ) : error ? (
          <p className="text-red-600">{error}</p>
        ) : (
          <table className="w-full table-auto border">
            <thead className="bg-gray-200 text-left">
              <tr>
    <th className="p-2 border">ID</th>
    <th className="p-2 border">Nombre</th>
    <th className="p-2 border">Precio</th>
    <th className="p-2 border">Categoría</th>
    <th className="p-2 border">Stock mín.</th> {/* ← NUEVA COLUMNA */}
    <th className="p-2 border">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {productos.map((producto) => (
                <tr key={producto.id} className="hover:bg-gray-100">
                  <td className="p-2 border">{producto.id}</td>
                  <td className="p-2 border">{producto.nombre}</td>
                  <td className="p-2 border">Gs. {producto.precio}</td>
                  <td className="p-2 border">{producto.categoria?.nombre || '-'}</td>
                  <td className="p-2 border">
                    <button
                      onClick={() => manejarEditar(producto.id)}
                      className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                    >
                      Editar
                    </button>
                  </td>
                  <td className={`p-2 border ${producto.stockActual <= producto.stockMinimo ? 'text-red-600 font-semibold' : ''}`}>
  {producto.stockMinimo ?? 'No definido'}
</td>

                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default ProductoAdmin;
